import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { aboutContent } from '../../data/portfolio';

const About: React.FC = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section
      id="about"
      ref={ref}
      className="bg-transparent py-16 sm:py-20"
      aria-labelledby="about-heading"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 px-4 sm:gap-10 sm:px-6 lg:flex-row lg:items-stretch lg:gap-14 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="glass-card relative flex w-full max-w-[240px] flex-none overflow-hidden bg-glass-light p-0 sm:max-w-xs dark:bg-glass-dark"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-brand-pink/12 via-transparent to-brand-purple/18" />
          <div className="relative z-10 aspect-[3/4] w-full">
            <img
              src="/media/profile/PortfolioImageCartoon.png"
              alt="Marco Biosa portrait"
              className="h-full w-full object-cover object-center"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, ease: 'easeOut', delay: 0.1 }}
          className="flex-1"
        >
          <h2
            id="about-heading"
            className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl md:text-3xl dark:text-slate-50"
          >
            About Marco
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-600 sm:mt-4 sm:text-base dark:text-slate-300">
            {aboutContent.bio}
          </p>

          <dl className="mt-5 grid gap-3 text-sm text-slate-600 sm:mt-6 sm:grid-cols-2 sm:gap-4 dark:text-slate-300">
            <div>
              <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                Location
              </dt>
              <dd className="mt-1">{aboutContent.location}</dd>
            </div>
            <div>
              <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                Availability
              </dt>
              <dd className="mt-1">{aboutContent.availability}</dd>
            </div>
            <div>
              <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                Interests
              </dt>
              <dd className="mt-1 flex flex-wrap gap-1.5">
                {aboutContent.interests.map((item) => (
                  <span
                    key={item}
                    className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-700 dark:bg-slate-800 dark:text-slate-200"
                  >
                    {item}
                  </span>
                ))}
              </dd>
            </div>
          </dl>
        </motion.div>
      </div>
    </section>
  );
};

export default About;



